module.exports = require('./helpers/bundle-url').getBundleURL('koVhS') + "Highlight2.389f4d9e.svg";